

function Words({ word }) {

    return (
        <>
          

                <div style={{
                    width:"50%",
                    margin:"auto"
                }} >


                    {word}

                </div>




        </>
    )

}

export default Words